import axiosClient from "./axiosClient";

const adsApi = {
  getAll: async () => {
    try {
      const response = await axiosClient.get("/ads/");
      
      // Validate response structure
      if (!response.data || !response.data.status || !response.data.data) {
        throw new Error('Invalid response format from ads API');
      }
      
      return response;
    } catch (error) {
      console.error('Error fetching ads:', error);
      // Return a structured error response
      return {
        data: {
          status: 'error',
          data: {},
          message: error.message || 'Failed to fetch ads'
        }
      };
    }
  },
};

export default adsApi; 